module.exports = __webpack_public_path__ + "img/storm-gray.fbad555e.svg";